<template>
  <Modal
    title="Add Payrun Process"
    :show-modal="title === 'Create'"
    @close="$emit('close')"
  >
    <Periodic
      class="my-6"
      :month-selected="monthSelected"
      :years-selected="yearsSelected"
    />
    <section class="flex items-center justify-between mb-4">
      <label for="output_file" class="w-1/5 text-sm text-gray-400 min-w-max"
        >Output File</label
      >
      <select
        class="w-full border focus:outline focus:outline-primary px-3 py-1.5 bg-white rounded-md text-sm"
        v-model="formPayrunProcess.outputFile"
        @change="selectOutputFile"
      >
        <option :value="null" selected disabled>Selected output file</option>
        <option
          v-for="(outputFile, i) in outputFiles"
          :key="i"
          class="px-2 py-1"
          :value="outputFile"
        >
          {{ `${outputFile.description} (${outputFile.type_file})` }}
        </option>
      </select>
    </section>

    <section class="mb-4">
      <SearchDropdown
        :label="'Company'"
        :label-top="true"
        :items="items"
        :query="query"
        @on-search="$emit('on-search', $event)"
        @on-remove-bank="onRemoveBank"
        @on-select-company="selectCompany"
        @on-get-companies="onGetCompanies"
      />
    </section>

    <div v-if="this.banksPayrun.length">
      <DetailBank
        v-for="(bank, index) in banksPayrun"
        :key="index"
        :company-id="bank.bank.company_id"
        :bank-name="bank.bank.bank_name"
        :rek-debet="bank.bank.account_number"
        :total-record="bank.total_record"
        :total-amount="formatCurrency(bank.total_amount)"
        :show-other-form="showOtherInput"
        :date="formPayrunProcess.date"
        @on-input="onInput"
      />
      <div class="mt-4" v-if="resultBankPayrun.length">
        <p class="text-sm">Result :</p>
        <DetailBank
          v-for="(bank, index) in resultBankPayrun"
          :key="index"
          :company-id="bank.bank.company_id"
          :bank-name="bank.bank.bank_name"
          :rek-debet="bank.bank.account_number"
          :total-record="bank.total_record"
          :total-amount="formatCurrency(bank.total_amount)"
          :date="formPayrunProcess.date"
          :input-value="formPayrunProcess.input"
          :is-show-input="true"
        />
      </div>
    </div>

    <template v-slot:footer>
      <section class="flex flex-row justify-end gap-x-2 w-52">
        <Button
          class="w-24 py-2 text-white bg-gray-400 rounded-md"
          @click="$emit('close')"
        >
          Close
        </Button>
        <Button
          class="w-24 py-2 text-white bg-green-500 rounded-md"
          :disabled="disbaled"
          @click="submitProcess"
        >
          Process
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Periodic from "@/components/Periodic.vue";
import SearchDropdown from "@/components/SearchDropdown/SearchDropdown.vue";
import DetailBank from "@/components/PayrunProcess/DetailBank.vue";
import { GetPeriodicAPI } from "@/actions/periodic";
import { getBankPayrun } from "@/actions/bank-payrun";
import { useToast } from "vue-toastification";

export default {
  name: "ModalCreate",
  components: {
    Modal,
    Periodic,
    SearchDropdown,
    DetailBank,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    monthSelected: {
      type: String,
      required: true,
    },
    yearsSelected: {
      type: String,
      required: true,
    },
    outputFiles: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    query: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formPayrunProcess: {
        outputFile: null,
        date: new Date(),
        input: "P",
        companies: [],
      },
      companyIds: [],
      showOtherInput: false,
      banksPayrun: [],
      resultBankPayrun: [],
    };
  },
  computed: {
    disbaled() {
      if (
        this.banksPayrun.length === 0 ||
        this.outputFiles === null ||
        this.resultBankPayrun.length === 0
      ) {
        return true;
      }

      return false;
    },
  },
  methods: {
    onGetCompanies(values) {
      this.formPayrunProcess.companies = values;
    },
    async selectCompany(value) {
      const companyId = value._id;
      const periodicId = await this.getPeriodic(companyId);
      const { data, message, success, code } = await getBankPayrun({
        companyId,
        periodicId,
      });
      if (success) {
        data.forEach((bankPayrun) => {
          const findBankPayrun = this.banksPayrun.find(
            (bank) => bank.bank._id === bankPayrun.bank._id
          );
          if (!findBankPayrun) {
            this.banksPayrun.push(bankPayrun);
          }
        });
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
      this.getResultBank();
    },
    onRemoveBank(value) {
      const objectWithId = this.banksPayrun.findIndex(
        (bank) => bank.bank.company_id === value._id
      );
      if (objectWithId > -1) {
        this.banksPayrun.splice(objectWithId, 1);
      }
      this.getResultBank();
    },
    getResultBank() {
      this.resultBankPayrun = [];
      if (this.banksPayrun.length > 1) {
        const checkIsEqual = this.banksPayrun.every(
          (bankPayrun) =>
            bankPayrun.account_number === this.banksPayrun[0].account_number
        );
        if (!checkIsEqual) {
          this.toast.error("Rekening debet tidak sama");
        }
        let total_record = 0;
        let total_amount = 0;
        this.banksPayrun.forEach((bankPayrun) => {
          total_record += bankPayrun.total_record;
          total_amount += bankPayrun.total_amount;
        });

        const objPayrun = {
          bank: this.banksPayrun[0].bank,
          total_record,
          total_amount,
        };
        this.resultBankPayrun.push(objPayrun);
      } else {
        let total_record = 0;
        let total_amount = 0;
        this.banksPayrun.forEach((bankPayrun) => {
          total_record += bankPayrun.total_record;
          total_amount += bankPayrun.total_amount;
        });

        const objPayrun = {
          bank: this.banksPayrun[0].bank,
          total_record,
          total_amount,
        };
        this.resultBankPayrun.push(objPayrun);
        // this.resultBankPayrun = this.banksPayrun;
      }
    },
    async getBanksPayrun() {
      const companyIds = this.formPayrunProcess.companies.map((company) => {
        return company._id;
      });

      const periodicIds = await this.getPeriodic(companyIds);
      const { data, message, success, code } = await getBankPayrun({
        companyIds,
        periodicIds,
      });

      if (success) {
        this.banksPayrun = data;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async getPeriodic(companyId) {
      const querySuperAdmin = `?company_id=${companyId}`;
      const response = await GetPeriodicAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }

      const periodics = response.data;

      const findPeriodic = periodics.find((period) => {
        return (
          period.periodic_month === this.monthSelected &&
          period.periodic_years === this.yearsSelected
        );
      });
      const periodicId = findPeriodic._id;
      return periodicId;
    },
    formatCurrency(number) {
      const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      });
      return formatter.format(Math.round(number));
    },
    onInput({ companyId, input }) {
      if (input !== "") {
        const findPInput = this.formPayrunProcess.inputs.find((inp) => {
          return inp.companyId === companyId;
        });

        if (findPInput) {
          findPInput.input = input;
        } else {
          this.formPayrunProcess.inputs.push({ companyId, input });
        }
      }
    },
    selectOutputFile() {
      const outputFile = this.formPayrunProcess.outputFile.type_file;
      if (outputFile === "csv") {
        this.showOtherInput = true;
      } else {
        this.showOtherInput = false;
      }
    },
    submitProcess() {
      const companyIds = this.formPayrunProcess.companies.map(
        (company) => company._id
      );
      const payload = {
        companyIds,
        outputFile: this.formPayrunProcess.outputFile._id,
        typeFile: this.formPayrunProcess.outputFile.type_file,
        dateTransaction: this.formPayrunProcess.date,
        input: this.formPayrunProcess.input,
        period: `${this.monthSelected} ${this.yearsSelected}`,
        rekDebet: this.resultBankPayrun[0].bank.account_number,
        totalRecord: this.resultBankPayrun[0].total_record,
        totalAmount: this.resultBankPayrun[0].total_amount,
      };
      this.$emit("on-process", payload);
    },
  },
};
</script>
